// extracted by mini-css-extract-plugin
module.exports = {"row":"course-card-ratings_row__D_lur","reviews-text":"course-card-ratings_reviews-text__rx1CN"};